// Tags the user's entry-point history entry so goBack knows where the app's
// stack starts. Without this, an in-app back button on a deep-linked page
// (Telegram inline button, shared URL, etc.) would either drop the user out
// of the app to wherever they came from, or do nothing if there's no prior
// history. replaceState (not pushState) — we're amending the entry the user
// is already on, not creating a new one.
export function initHistory() {
	const isExternalReferrer = !document.referrer ||
		document.referrer.indexOf(window.location.host) === -1;

	const currentState = window.history.state || {};

	if (isExternalReferrer && !currentState.appIsRoot) {
		const newState = { ...currentState, appIsRoot: true };
		window.history.replaceState(newState, '', window.location.href);
	}
}

import { isWebPlatform } from './platform.js';

// In-app back: at the entry point, route to a known-safe app location instead
// of history.back() (which would leave the app). Anywhere else, walk the
// in-app stack normally. At the entry point we also confirm first — deep
// entries (TG bot keyboard button → /app/payments, shared links) shouldn't
// throw the user back to the dashboard on an accidental tap.
//
// The htmx-request class is added pre-navigation so the existing spinner CSS
// gives feedback while the page transitions — useful on slow Telegram
// WebViews. The classList guard is defensive: some templ wirings pass an
// Alpine proxy (`@click="goBack(this)"`) instead of a DOM element, where
// `.classList` is undefined.
export async function goBack(el) {
	const setLoading = (on) => {
		if (el && el.classList) {
			el.classList[on ? 'add' : 'remove']('htmx-request');
		}
	};

	const state = window.history.state;

	if (state && state.appIsRoot) {
		const ok = await appConfirm("Leave to dashboard?");
		if (!ok) return;
		setLoading(true);
		window.location.href = window.appBasePath || "/";
		return;
	}

	setLoading(true);
	window.history.back();
}

function appConfirm(message) {
	return new Promise((resolve) => {
		if (!isWebPlatform() && window.Telegram?.WebApp?.showConfirm) {
			Telegram.WebApp.showConfirm(message, resolve);
		} else {
			resolve(window.confirm(message));
		}
	});
}